import { useDispatch, useSelector } from "react-redux";
import { Box, Button, TextField } from "@mui/material";
import MaterialTable, { MTableAction } from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";

import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import {
  AddECMSClearanceTypeAction,
  DeleteECMSClearanceTypeAction,
  UpdateECMSClearanceTypeAction,
} from "../../../../../store/Employee/ECMS/Action";

const ClearanceDepartmentGrid = () => {
  const dispatch = useDispatch();

  const { clearanceTypeLoading, clearanceTypeData } = useSelector(
    (state) => state?.EmployeeReducer?.ECMSReducer
  );
  const structureData = (clearanceTypeData || [])?.map((item) => ({
    ...item,
    clearance_approver_fk: {
      employee_id: item?.clearance_approver_fk,
      name: item?.employee_name,
    },
  }));
  const { employees_options } = useSelector(
    (state) => state.EmployeeReducer.EmployeesReducer
  );

  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });

  useEffect(() => {
    dispatch(GetEmployeesAction({ is_active: true }));
  }, [dispatch]);

  useEffect(() => {
    if (employees_options?.length) {
      setEmployeesData({
        load: false,
        values: employees_options?.filter(
          (el) =>
            el?.core_hr_user_type === "Owner" ||
            el?.core_hr_user_type === "Admin"
        ),
      });
    }
  }, [employees_options]);

  return (
    <Box>
      <MaterialTable
        isLoading={clearanceTypeLoading}
        columns={[
          {
            title: "Asset Type",
            cellStyle: { padding: "10px 10px 0px 15px" },
            field: "clearance_type",
            validate: (rowData) => {
              if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
              if (!rowData?.clearance_type?.trim()) {
                return "Type cannot be empty";
              }
              return "";
            },
            editComponent: (props) => {
              return (
                <Box sx={{ width: "95%" }}>
                  <TextField
                    required={true}
                    variant="standard"
                    fullWidth
                    value={props?.value}
                    onChange={(e) => props.onChange(e.target.value)}
                  />
                </Box>
              );
            },
          },
          {
            title: "Approver",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "clearance_approver_fk",
            grouping: false,
            render: (rowData) => rowData.clearance_approver_fk?.name,
            validate: (rowData) => {
              if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
              if (!rowData?.clearance_approver_fk) {
                return "Approver cannot be empty";
              }
              return "";
            },
            editComponent: (props) => (
              <Box sx={{ width: "95%" }}>
                <SelectableSearch
                  fullWidth
                  required
                  variantType="standard"
                  size="small"
                  loading={() => {}}
                  value={props.value || ""}
                  fieldLabel="name"
                  name="employee_id"
                  onChangeEvent={(e, v) => {
                    props.onChange(v);
                  }}
                  data={employeesData}
                />
              </Box>
            ),
          },
        ]}
        data={structureData || []}
        icons={{
          Add: () => (
            <Button
              variant="contained"
              className="mpl-primary-btn"
              style={{
                minWidth: 0,
                width: "82px",
                height: "35px",
                padding: "2px 12px",
                textTransform: "none",
              }}
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          ),
          Edit: (props) => <EditIcon sx={{color: props?.disabled ? "#bdbdbd" : "#637381"}} />,
          Delete: (props) => <DeleteIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381"}} />,
        }}
        editable={{
          onRowAdd: (newRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.clearance_type?.trim()) {
                return reject();
              }
              if (!newRow?.clearance_approver_fk?.employee_id) {
                return reject();
              }
              dispatch(
                AddECMSClearanceTypeAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          isEditable: rowData => !rowData?.is_utilised,
          isDeletable: rowData => !rowData?.is_utilised,
          onRowUpdate: (newRow, oldRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.clearance_type?.trim()) {
                return reject();
              }
              if (!newRow?.clearance_approver_fk?.employee_id) {
                return reject();
              }
              dispatch(
                UpdateECMSClearanceTypeAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowDelete: (selectedRow) =>
            new Promise((resolve, reject) => {
              dispatch(
                DeleteECMSClearanceTypeAction({
                  ...selectedRow,
                })
              );
              setTimeout(() => resolve(), 1000);
            }),
        }}
        options={{
          maxBodyHeight: "250px",
          minBodyHeight: "250px",
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "5px 10px 5px 15px", fontWeight: "bold" },
          sorting: false,
          search: false,
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: false,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          addRowPosition: "first",
        }}
        components={{
          Action: (props) => {
            const ActionComponent = props?.components?.Action || MTableAction;

            if (
              props?.action?.icon &&
              typeof props?.action?.icon === "function"
            ) {
              return (
                <Box
                  sx={{
                    "& .MuiIconButton-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                >
                  <ActionComponent {...props} />
                </Box>
              );
            }
            return <ActionComponent {...props} />;
          },
        }}
        title={""}
      />
    </Box>
  );
};

export default ClearanceDepartmentGrid;
